"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _logo = _interopRequireDefault(require("./logo.png"));

var _hearts_animation = _interopRequireDefault(require("./hearts_animation.svg"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var options = {};
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var Footer = /*#__PURE__*/function (_React$Component) {
    _inherits(Footer, _React$Component);

    var _super = _createSuper(Footer);

    function Footer() {
      var _this;

      _classCallCheck(this, Footer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "renderLink", function (theme, link, text) {
        var sameWindow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return /*#__PURE__*/_react["default"].createElement("a", {
          className: theme.link,
          href: link,
          target: sameWindow ? '_self' : '_blank',
          rel: "noopener noreferrer",
          key: text
        }, text);
      });

      _defineProperty(_assertThisInitialized(_this), "renderClaim", function () {
        var _this$props = _this.props,
            theme = _this$props.theme,
            claimText = _this$props.claimText,
            animated = _this$props.animated,
            utmParams = _this$props.utmParams;
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://perspective.co/".concat(utmParams),
          target: "_blank",
          rel: "noopener noreferrer",
          className: (0, _classnames["default"])(theme.claimButton, _defineProperty({}, theme.dark, _this.isOnLightBg))
        }, animated && /*#__PURE__*/_react["default"].createElement("img", {
          src: _hearts_animation["default"],
          alt: "animated hearts",
          className: theme.hearts
        }), /*#__PURE__*/_react["default"].createElement("img", {
          src: _logo["default"],
          alt: "logo",
          className: theme.claimLogo
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: (0, _classnames["default"])(theme.claimText, _defineProperty({}, theme.dark, _this.isOnLightBg))
        }, claimText));
      });

      _defineProperty(_assertThisInitialized(_this), "renderConnectionElement", function (key) {
        var theme = _this.props.theme;
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: theme.connector,
          key: key
        }, "\xB7");
      });

      return _this;
    }

    _createClass(Footer, [{
      key: "render",
      value: function render() {
        var theme = this.props.theme;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.wrapperClass
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.innerContent
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: this.linksClass
        }, this.linksToRender), this.brandingElement));
      }
    }, {
      key: "isOnLightBg",
      get: function get() {
        var color = (0, _tinycolor["default"])(this.props.bgColorReference);
        return color.isLight();
      }
    }, {
      key: "linksClass",
      get: function get() {
        var _cn3;

        var _this$props2 = this.props,
            theme = _this$props2.theme,
            legalText = _this$props2.legalText,
            legalLink = _this$props2.legalLink,
            termsText = _this$props2.termsText,
            termsLink = _this$props2.termsLink,
            cookiesLinkComponent = _this$props2.cookiesLinkComponent;
        var hasLegal = legalText && legalLink;
        var hasTerms = termsText && termsLink;
        return (0, _classnames["default"])(theme.links, (_cn3 = {}, _defineProperty(_cn3, theme.spaced, hasLegal || hasTerms || cookiesLinkComponent), _defineProperty(_cn3, theme.dark, this.isOnLightBg), _cn3));
      }
    }, {
      key: "wrapperClass",
      get: function get() {
        var _this$props3 = this.props,
            theme = _this$props3.theme,
            className = _this$props3.className,
            noInteraction = _this$props3.noInteraction;
        return (0, _classnames["default"])(theme.footerWrapper, _defineProperty({}, theme.noInteraction, noInteraction), className);
      }
    }, {
      key: "brandingElement",
      get: function get() {
        var branding = this.props.branding;
        return branding ? this.renderClaim() : null;
      }
    }, {
      key: "legalLinkElement",
      get: function get() {
        var _this$props4 = this.props,
            legalLink = _this$props4.legalLink,
            legalText = _this$props4.legalText,
            theme = _this$props4.theme;
        return legalLink && legalText ? this.renderLink(theme, legalLink, legalText) : null;
      }
    }, {
      key: "termsLinkElement",
      get: function get() {
        var _this$props5 = this.props,
            termsLink = _this$props5.termsLink,
            termsText = _this$props5.termsText,
            theme = _this$props5.theme;
        return termsLink && termsText ? this.renderLink(theme, termsLink, termsText) : null;
      }
    }, {
      key: "cookiesLinkElement",
      get: function get() {
        var _this$props6 = this.props,
            cookiesLinkComponent = _this$props6.cookiesLinkComponent,
            theme = _this$props6.theme;
        var Link = cookiesLinkComponent;
        return cookiesLinkComponent ? /*#__PURE__*/_react["default"].createElement(Link, {
          className: theme.link,
          key: "cookies"
        }) : null;
      }
    }, {
      key: "linksToRender",
      get: function get() {
        var _this2 = this;

        var links = [this.legalLinkElement, this.termsLinkElement, this.cookiesLinkElement];
        var existingLinks = [];
        links.forEach(function (link) {
          if (link !== null) {
            existingLinks.push(link);
          }
        });
        var linksToRender = [];
        existingLinks.forEach(function (link, index) {
          if (link) {
            linksToRender.push(link);

            if (index !== existingLinks.length - 1 && !!existingLinks[index + 1]) {
              linksToRender.push(_this2.renderConnectionElement("connection-".concat(index)));
            }
          }
        });
        return linksToRender;
      }
    }]);

    return Footer;
  }(_react["default"].Component);

  Footer.displayName = identifier;
  Footer.propTypes = {
    legalLink: _propTypes["default"].string,
    legalText: _propTypes["default"].string,
    termsLink: _propTypes["default"].string,
    termsText: _propTypes["default"].string,
    cookiesText: _propTypes["default"].string,
    cookiesLink: _propTypes["default"].string,
    claimText: _propTypes["default"].string,
    bgColorReference: _propTypes["default"].string,
    branding: _propTypes["default"].bool,
    animated: _propTypes["default"].bool,
    noInteraction: _propTypes["default"].bool,
    theme: _propTypes["default"].shape({
      footerWrapper: _propTypes["default"].string,
      links: _propTypes["default"].string,
      spaced: _propTypes["default"].string,
      link: _propTypes["default"].string
    }),
    className: _propTypes["default"].string,
    utmParams: _propTypes["default"].string
  };
  Footer.defaultProps = {
    branding: true,
    animated: true,
    noInteraction: false,
    legalText: 'Impressum',
    termsText: 'Datenschutz',
    cookiesLinkComponent: null,
    claimText: 'We use Perspective',
    bgColorReference: '#FFFFFF',
    utmParams: ''
  };
  return Footer;
};

var _default = factory;
exports["default"] = _default;